import PropTypes from 'prop-types';
import Chart from '../../components/Chart';

import './style.scss';

const MultipleHydrobasinsCharts = ({charts}) => {
	return (
		<>
			{charts?.map(chart => {
				const {componentKey, sources} = chart;
				if (componentKey) {
					return (
						<Chart
							key={componentKey}
							componentKey={componentKey}
							sources={sources}
						/>
					);
				} else {
					return null;
				}
			})}
		</>
	);
};

MultipleHydrobasinsCharts.propTypes = {
	charts: PropTypes.array,
	chartComponentKeyByChartKey: PropTypes.object,
};

export default MultipleHydrobasinsCharts;
